var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCopyV1Line(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6031 26H7.65002C5.58221 26 3.90002 24.3178 3.90002 22.25V9.54688C3.90002 7.47906 5.58221 5.79688 7.65002 5.79688H16.6031C18.671 5.79688 20.3531 7.47906 20.3531 9.54688V22.25C20.3531 24.3178 18.671 26 16.6031 26ZM7.65002 7.67188C6.61621 7.67188 5.77502 8.51306 5.77502 9.54688V22.25C5.77502 23.2838 6.61621 24.125 7.65002 24.125H16.6031C17.637 24.125 18.4781 23.2838 18.4781 22.25V9.54688C18.4781 8.51306 17.637 7.67188 16.6031 7.67188H7.65002ZM24.1031 19.9062V5.75C24.1031 3.68219 22.421 2 20.3531 2H9.9469C9.42908 2 9.0094 2.41968 9.0094 2.9375C9.0094 3.45532 9.42908 3.875 9.9469 3.875H20.3531C21.387 3.875 22.2281 4.71619 22.2281 5.75V19.9062C22.2281 20.4241 22.6478 20.8438 23.1656 20.8438C23.6835 20.8438 24.1031 20.4241 24.1031 19.9062Z",
    fill: "#130F40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopyV1Line);
export default __webpack_public_path__ + "static/media/icon-copy-v1-line.07c57fea5ba0aef5781af1d41b9b8bb1.svg";
export { ForwardRef as ReactComponent };